import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IClusterDashboard, IConstellationInfo, ClusterRemoteManagement } from "../../model/CarbonExternalModels";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";

interface IState {
    constellations: { [id: string]: IConstellationInfo };
    pairingCode: string;
    dashboards: { [id: string]: IClusterDashboard };
    clusterRemoteManagements: { [id: string]: ClusterRemoteManagement };
}

const initialState: IState = {
    constellations: {},
    pairingCode: "",
    dashboards: {},
    clusterRemoteManagements: {},
};

export const constellationsSlice = createSlice({
    name: "constellationsSlice",
    initialState,
    reducers: {
        // Internal Management
        setConstellations: (state, action: PayloadAction<{ [id: string]: IConstellationInfo }>) => {
            state.constellations = action.payload;
        },
        addConstellation: (state, action: PayloadAction<IConstellationInfo>) => {
            const constellation: IConstellationInfo = action.payload;
            state.constellations[constellation.definition.id.value] = constellation;
        },
        updateConstellationHeader: (state, action: PayloadAction<IConstellationInfo>) => {
            // const constellation: IConstellationInfo = action.payload;
            // const foundConstellation = state.constellations[constellation.definition.id.value];
        },
        removeConstellation: (state, action: PayloadAction<string>) => {
            const id: string = action.payload;

            const foundConstellation = state.constellations[id];

            if (foundConstellation) {
                delete state.constellations[id];
            }
        },
        setPairingCode: (state: IState, action: PayloadAction<string>) => {
            state.pairingCode = action.payload;
        },
        addOrUpdateDashboards: (state, action: PayloadAction<IClusterDashboard[]>) => {
            const dashboards: IClusterDashboard[] = action.payload;

            for (let i = 0; i < dashboards.length; i++) {
                state.dashboards[dashboards[i].id?.value] = dashboards[i];
            }
        },
        removeCluster(state, action: PayloadAction<StringID>) {
            let constellationID = "";
            let foundCluster = undefined;

            for (const id in state.constellations) {
                for (let i = 0; i < state.constellations[id].cluster.length; i++) {
                    if (state.constellations[id].cluster[i].id.value === action.payload.value) {
                        constellationID = id;
                        foundCluster = state.constellations[id].cluster[i];
                        state.constellations[id].cluster.splice(i, 1);
                        break;
                    }
                }
            }

            if (foundCluster) {
                delete state.constellations[constellationID].cluster[foundCluster.id.value];
            }
        },
        // Cluster Remote Management
        setClusterRemoteManagements: (state, action: PayloadAction<{ [id: string]: ClusterRemoteManagement }>) => {
            state.clusterRemoteManagements = action.payload;
        },
        addUpdateClusterRemoteManagement: (state, action: PayloadAction<ClusterRemoteManagement>) => {
            const crm: ClusterRemoteManagement = action.payload;
            state.clusterRemoteManagements[crm.id.value] = crm;
        },
    },
});

export const ConstellationsActions = constellationsSlice.actions;

export default constellationsSlice.reducer;
